
// import mixpanel from "mixpanel-browser"
var MIX = {
    /**
     * 追踪页面
     * @param {页面名字} pageName 
     * @param {从那个页面过来} from 
     */
    trackPageViewed(pageName, from='') {
        return;
        console.log('track---trackPageViewed---', pageName, from);
        if(from !== '') {
            mixpanel.track('page_viewed', {"page_name": pageName, "from": from})
        }else {
            mixpanel.track('page_viewed', {"page_name": pageName})
        }
    },
    /**
     * 追踪按钮事件
     * @param {按钮事件} btnName 
     */
    trackButtonClicked(btnName){
        return;
        console.log('track---trackButtonClicked---', btnName);
        mixpanel.track('button_clicked', {'bt_name': btnName});
    },
    /**
     * 追踪下单事件
     * @param {参数} params 
     */
    trackOrderCreated(params){
        return;
        console.log('track---trackOrderCreated---', params);
        mixpanel.track('order_created', params);
    },
    /**
     * 追踪付款事件
     * @param {参数} params 
     */
    trackMoneyPaid(params){
        return;
        console.log('track---trackMoneyPaid---', params);
        mixpanel.track('money_paid', params);
    },
}

export {
    MIX
}